import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import List from "@/components/List";
import ListRow from "@/components/Row/ListRow/index";
import { useRtRecommendQuery } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
const RECOMMEND_PAGE_LIMIT = 5;
export default function RtRecommendList(_ref) {
  let {
    elementId,
    header
  } = _ref;
  const _useRtRecommendQuery = useRtRecommendQuery({
      variables: {
        location: `${window.location.origin}${window.location.pathname}`,
        elementIds: [elementId]
      },
      fetchPolicy: "cache-first"
    }),
    {
      data
    } = _useRtRecommendQuery,
    result = _objectWithoutProperties(_useRtRecommendQuery, _excluded);
  if (!(data !== null && data !== void 0 && data.recommend)) return null;
  const items = data === null || data === void 0 ? void 0 : data.recommend.find(data => data.elementId === elementId);
  return /*#__PURE__*/_jsx(List, _objectSpread(_objectSpread({}, result), {}, {
    itemComponent: ListRow,
    header: header,
    items: items,
    limit: RECOMMEND_PAGE_LIMIT,
    viewTypeClassName: "list",
    loadMore: false
  }));
}